<template>
  <div class="app-container">
    <van-nav-bar title="服务评价" left-arrow @click-left="$router.back()" />
    <my-company />
    <br>
    <van-tabs v-model="active">
      <van-tab title="服务评价">
        <van-notice-bar v-if="tip" :scrollable="false" :text="tip" />
        <van-row style="margin-top: 20px;">
          <van-col span="8" offset="2">企业综合评分</van-col>
          <van-col span="10">
            <van-rate :disabled="hasEvaluated" :count="3" color="red" v-model="form.cli_satis" />
          </van-col>
          <van-col span="4">{{ form.cli_satis | fmConst('SERVICE_SCORE') }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" style="text-align: center; margin-top: 20px;">
          <van-col span="6">
            <van-button :disabled="hasEvaluated" plain type="info" :color="btn[0].color" size="small"
                        @click="handleSelected(0)">服务态度</van-button>
          </van-col>
          <van-col span="6">
            <van-button :disabled="hasEvaluated" plain type="info" :color="btn[1].color" size="small"
                        @click="handleSelected(1)">业务熟练度</van-button>
          </van-col>
          <van-col span="6">
            <van-button :disabled="hasEvaluated" plain type="info" :color="btn[2].color" size="small"
                        @click="handleSelected(2)">服务时效</van-button>
          </van-col>
          <van-col span="6">
            <van-button :disabled="hasEvaluated" plain type="info" :color="btn[3].color" size="small"
                        @click="handleSelected(3)">&nbsp;&nbsp;&nbsp;其他&nbsp;&nbsp;&nbsp;</van-button>
          </van-col>
        </van-row>
        <van-row style="margin-top: 20px;">
          <van-col span="22" offset="1">
            <base-textarea v-model="form.comment" label="" style="border: 1px solid #d1d1d1;" :disabled="hasEvaluated"
                           :rows="3" :maxlength="200" placeholder="请选择评价标签，并留下您宝贵的建议" />
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-between" style="padding:0 13px;font-size: 12px; color: #B0B0B0;">
          <van-col span="8" style="text-align: left;">评价已匿名</van-col>
          <van-col span="16" style="text-align: right;">您的真实评价能帮助更多的小伙伴</van-col>
        </van-row>
        <van-row style="margin-top: 30px; ">
          <van-col span="8" offset="2">服务态度满意度</van-col>
          <van-col span="10">
            <van-rate :disabled="hasEvaluated" color="red" :count="3" v-model="form.ser_attitude" /></van-col>
          <van-col span="4">{{ form.ser_attitude | fmConst('SERVICE_SCORE') }}</van-col>
        </van-row>
        <van-row style="margin-top: 20px;">
          <van-col span="8" offset="2">业务熟练满意度</van-col>
          <van-col span="10">
            <van-rate :disabled="hasEvaluated" color="red" :count="3" v-model="form.pro_business" /></van-col>
          <van-col span="4">{{ form.pro_business | fmConst('SERVICE_SCORE') }}</van-col>
        </van-row>
        <van-row style="margin-top: 20px;">
          <van-col span="8" offset="2">服务时效满意度</van-col>
          <van-col span="10">
            <van-rate :disabled="hasEvaluated" color="red" :count="3" v-model="form.time_satis" /></van-col>
          <van-col span="4">{{ form.time_satis | fmConst('SERVICE_SCORE') }}</van-col>
        </van-row>
        <van-col :span="22" :offset="1">
          <br>
          <base-button size="large" :round="true" :disabled="hasEvaluated" @click="handleSave">提交评价</base-button>
        </van-col>
      </van-tab>
      <van-tab title="历史评价">
        <van-pull-refresh v-model="refreshing" @refresh="query()">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="query()"
          >
            <template v-for="row in data">
              <van-divider :style="{ color: '#666', borderColor: '#666', padding: '0 16px' }">
                {{ row.pre_date }}
              </van-divider>
              <van-row style="margin-top: 30px; ">
                <van-col span="8" offset="2">企业综合评分</van-col>
                <van-col span="10">
                  <van-rate :disabled="true" color="red" :count="3" v-model="row.cli_satis" /></van-col>
                <van-col span="4">{{ row.cli_satis | fmConst('SERVICE_SCORE') }}</van-col>
              </van-row>
              <van-row style="margin-top: 20px; ">
                <van-col span="8" offset="2">服务态度满意度</van-col>
                <van-col span="10">
                  <van-rate :disabled="true" color="red" :count="3" v-model="row.ser_attitude" /></van-col>
                <van-col span="4">{{ row.ser_attitude | fmConst('SERVICE_SCORE') }}</van-col>
              </van-row>
              <van-row style="margin-top: 20px;">
                <van-col span="8" offset="2">业务熟练满意度</van-col>
                <van-col span="10">
                  <van-rate :disabled="true" color="red" :count="3" v-model="row.pro_business" /></van-col>
                <van-col span="4">{{ row.pro_business | fmConst('SERVICE_SCORE') }}</van-col>
              </van-row>
              <van-row style="margin-top: 20px;">
                <van-col span="8" offset="2">服务时效满意度</van-col>
                <van-col span="10">
                  <van-rate :disabled="true" color="red" :count="3" v-model="row.time_satis" /></van-col>
                <van-col span="4">{{ row.time_satis | fmConst('SERVICE_SCORE') }}</van-col>
              </van-row>
              <van-row style="margin-top: 20px;" v-if="row.commentArray && row.commentArray[0]">
                <van-col span="22" offset="2">
                  {{ row.commentArray[0] }}
                </van-col>
              </van-row>
              <van-row style="margin-top: 20px;" v-if="row.commentArray && row.commentArray[1]">
                <van-col span="22" offset="2">
                  {{ row.commentArray[1] }}
                </van-col>
              </van-row>
            </template>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { addServiceScore, getServiceScoreList } from '@/api/service-score'
import MyCompany from '@/components/commons/my-company'
import {mapGetters} from "vuex";
export default {
  components: { MyCompany },
  data() {
    return {
      active: 0,
      loading: false,
      finished: false,
      refreshing: false,

      showClientList: false,
      hasEvaluated: false,
      tip: '',
      prevYM: '',
      data: [],
      form: {
        cli_satis: 0,
        ser_attitude: 0,
        pro_business: 0,
        time_satis: 0,
        comment: ''
      },
      btn: [{
        color: '#989898'
      }, {
        color: '#989898'
      }, {
        color: '#989898'
      }, {
        color: '#989898'
      }]
    }
  },
  computed: {
    ...mapGetters(['currClient', 'currDate'])
  },
  created() {
    const currYM = new Date(this.currDate)
    currYM.setMonth(currYM.getMonth() - 1)
    this.prevYM = this.Utils.df(currYM)
    this.query()
  },
  methods: {
    loadServiceScore(row) {
      Object.assign(this.form, row)
      const commentArray = this.form.comment.split(':::')
      if (commentArray.length === 2) {
        const btnCommentArray = commentArray[0].split(',')
        if (btnCommentArray && btnCommentArray.length > 0) {
          btnCommentArray.forEach((comment, ind) => {
            if (comment) {
              this.btn[ind].color = '#1989fa'
            } else {
              this.btn[ind].color = '#989898'
            }
          })
        }
        this.form.comment = commentArray[1]
      }
    },
    query() {
      this.finished = false
      this.loading = true

      if (this.refreshing) {
        this.data = []
        this.refreshing = false
      }

      this.hasEvaluated = false
      this.tip = ''
      getServiceScoreList({
        client_id: this.currClient.client_id,
        sort: 'id',
        order: 'desc'
      }).then(resp => {
        this.data = resp.rows || []
        for (let i = 0, j = this.data.length; i < j; i++) {
          const row = this.data[i]
          row.commentArray = row.comment.split(':::')
          if (row.pre_date === this.prevYM) {
            this.hasEvaluated = true
            this.loadServiceScore(row)
            this.tip = '您本月已评价！'
            break
          }
        }
        this.loading = false
        this.finished = true
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    handleSelected(index) {
      this.btn[index].color = (this.btn[index].color === '#989898') ? '#1989fa' : '#989898'
    },
    handleSave() {
      if (!this.form.cli_satis) {
        this.warning('请选择企业评分')
      } else if (!this.form.ser_attitude) {
        this.warning('请选择服务态度满意度')
      } else if (!this.form.pro_business) {
        this.warning('请选择业务熟练满意度')
      } else if (!this.form.time_satis) {
        this.warning('请选择服务时效满意度')
      } else {
        const postData = {}
        Object.assign(postData, this.form)
        postData.client_id = this.currClient.client_id
        postData.pre_date = this.prevYM

        const btnComment = []
        if (this.btn[0].color === '#989898') {
          btnComment.push('')
        } else {
          btnComment.push('服务态度')
        }
        if (this.btn[1].color === '#989898') {
          btnComment.push('')
        } else {
          btnComment.push('业务熟练度')
        }
        if (this.btn[2].color === '#989898') {
          btnComment.push('')
        } else {
          btnComment.push('服务时效')
        }
        if (this.btn[3].color === '#989898') {
          btnComment.push('')
        } else {
          btnComment.push('其他')
        }
        postData.comment = btnComment.join(',') + ':::' + this.form.comment
        addServiceScore(postData).then(resp => {
          this.hasEvaluated = true
          this.tip = '您本月已评价！'
          this.success('评价成功')
        })
      }
    }
  }
}
</script>

<style scoped>
.van-row >>> .van-rate__icon {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/service-score.vue